/**
 * Emissions Tracker App Entry Point
 *
 * This file is the entry point for the emissions tracker app.
 */

import { HydratedRouteInterface } from '../../types/routes';
import { rootAppPath, getRootAppPath } from './routes';
import { EmissionsTrackerRoute } from './index';

export const emissionsTrackerRouteEntry: HydratedRouteInterface = {
  id: 'emissions_tracker_entry',
  label: 'Emissions Tracker',
  path: `/${rootAppPath}`,
  exact: false,
  auth: true,
  getRootAppPath,
  component: EmissionsTrackerRoute,
};
